import { App } from './pages/app/App';
import { createRoot } from 'react-dom/client';
import 'src/app/styles/index.scss';
import 'src/shared/styles/mediaQueries.scss';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(<App />);
